import { NotificationName } from '@evidentid/gateway-api-client/src/models';
import { NotificationType } from '@evidentid/tprm-portal-lib/models/notification-configuration';

export function getNotificationType(notificationName: NotificationName): NotificationType {
    switch (notificationName) {
        case NotificationName.newRequestReminder:
            return NotificationType.new;
        case NotificationName.nonCompliantRequestReminder:
            return NotificationType.nonCompliant;
        case NotificationName.expiringRequestReminder:
            return NotificationType.expiring;
        case NotificationName.newEntityBodyRequestReminder:
            return NotificationType.newEntity;
        default:
            throw new Error(`Unknown notification name: ${notificationName}`);
    }
}
